import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  farmId: null,
  boundary: [],
  gridCells: [],
  // Sidebar 가 조회한 농장 목록을 여기 보관해 FarmOverlay 등 다른 컴포넌트가
  // /api/farms 를 중복 호출하지 않고 이 상태만 구독하게 한다.
  farmList: [],
  // AI 병해 결과가 BE 에 저장되면 WS(DIAGNOSIS_UPDATED)로 알림이 온다. 소켓 훅이 여기에 담고
  // 지도(DroneMapTest)가 구독해 진단 오버레이와 회차 목록을 다시 조회한다.
  // { farmId, missionLogId, cellIds, at } 형태. at 은 같은 회차가 연달아 와도 효과가 다시 돌게 하는 값.
  diagnosisUpdate: null,
  // 농장에 연결된 에너지 장치(스마트폴 · 태양광큐브) 목록. 정보 탭이 /dashboard/{id}/info 를
  // 5초마다 받아 여기 담고, 지도(EnergyDeviceMarkers)가 구독해 마커를 그린다 — 지도가 따로
  // 부르지 않아 호출이 늘지 않는다. 데모는 DemoScenarioContext 가 같은 모양을 채운다.
  // { mode: POLE | EDGE_ONLY | FOG | NONE, devices: [{ id, name, serialNum, deviceType, role,
  //   latitude, longitude, operatingStatus, batteryCharge, isConnected, lastSeenAt }] }
  energyDevices: null,
  // 지도 마커를 눌러 정보 탭의 그 장치 줄을 펼칠 때. { id, at }
  // at 은 같은 장치를 다시 눌러도(접었다가) 다시 열리게 하는 값.
  energyDeviceFocus: null,
};

const farmSlice = createSlice({
  name: "farm",
  initialState,
  reducers: {
    setFarmId: (state, action) => {
      state.farmId = action.payload;
    },
    setBoundary: (state, action) => {
      state.boundary = action.payload;
    },
    setGridCells: (state, action) => {
      state.gridCells = action.payload;
    },
    replaceFarmList: (state, action) => {
      state.farmList = action.payload;
    },
    appendFarmList: (state, action) => {
      state.farmList = [...state.farmList, ...action.payload];
    },
    setDiagnosisUpdate: (state, action) => {
      state.diagnosisUpdate = action.payload;
    },
    setEnergyDevices: (state, action) => {
      state.energyDevices = action.payload ?? null;
    },
    setEnergyDeviceFocus: (state, action) => {
      state.energyDeviceFocus = action.payload ?? null;
    },
  },
});

export const {
  setFarmId,
  setBoundary,
  setGridCells,
  replaceFarmList,
  appendFarmList,
  setDiagnosisUpdate,
  setEnergyDevices,
  setEnergyDeviceFocus,
} = farmSlice.actions;
export default farmSlice.reducer;
